export type DarkVenueHeatmapApiOkResponse = {
    symbol: string;
    venueWeights: { [venue: string]: number };
    updated: string;
    totalWeight: number;
};

export type DarkVenueHeatmapApiErrorResponse = {
    status: number;
    message: string;
    timestamp: number;
    details: unknown;
};

export type DarkVenueHeatmapApiResponse =
    | DarkVenueHeatmapApiOkResponse
    | DarkVenueHeatmapApiErrorResponse;

export function isErrorResponse(
    response: DarkVenueHeatmapApiResponse | undefined
): response is DarkVenueHeatmapApiErrorResponse {
    const error = response as DarkVenueHeatmapApiErrorResponse;
    return !!error?.message;
}

export function isOkResponse(
    response: DarkVenueHeatmapApiResponse | undefined
): response is DarkVenueHeatmapApiOkResponse {
    return !isErrorResponse(response);
}
